import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {from, Observable} from 'rxjs';
import {finalize, map} from 'rxjs/operators';
import {State} from '../state';
import {StateContext} from '../state.context';

/**
 * Returns the user to the view page that started the ForgeRock journey.
 */
@Injectable({
  providedIn: "root"
})
export class ExitEditState implements State {
  name = 'ExitState';

  constructor(
    private stateContext: StateContext,
    private router: Router
  ) {}

  /**
   * Navigate to the journey owner's view page and clear its transient data.
   */
  start(): Observable<void> {
    console.debug(`🔑 SERVICE:exit$`);
    const journey = this.stateContext.getJourney();
    journey.onExit?.();
    return from(this.router.navigate(journey.exitRoute)).pipe(
      map(() => void 0),
      finalize(() => this.stateContext.clearJourney())
    );
  }
}
